import React, { useEffect, useState } from "react";
import { FaFilePdf, FaFileExcel, FaFileWord, FaFileImage, FaFile } from "react-icons/fa";
import { Button, FormLabel, Row, Col } from "react-bootstrap";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
import { TableVirtuoso } from "react-virtuoso";
import noImage from "../images/clicktoAdd.png";
import { DropDwnDown, DropDwnUp } from "./Icons";
import {
  InputCheckbox,
  NumberFormatInputbox,
  InputTextbox,
} from "./UIComponents";
import PaginationComponent from "./PaginationComponent";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  dateFormate,
} from "./Util";

const VirtuosoTable = ({ style, context, ...tblProps }) => (
  <table
    id="custom-table"
    className={`${tblProps.isResizable ? "resizable" : ""}`}
    {...tblProps}
    style={{ ...style }}
  />
);

const VirtuosoTableRow = ({ context, ...rowProps }) => {
  const row = context.data[rowProps["data-index"]];
  return (
    <tr
      {...rowProps}
      className={context.getRowClassName(row, rowProps["data-index"])}
    />
  );
};

const virtuosoComponents = {
  Table: VirtuosoTable,
  TableRow: VirtuosoTableRow,
};
export default function CustomTable(props) {

  const [data, setData] = useState(props.data);
  const [columns, setColumns] = useState(props.columns);

  const [subHeaderData, setSubHeaderData] = useState(props.subHeaderData);

  const [isFullscreen, setFullscreen] = useState(false);

  const [sorted, onData] = useState(props.sorted);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });




  useEffect(() => {
    setData(props.data);
    if (sortConfig) {
      onData(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    setColumns(props.columns);
  }, [props.columns]);

  useEffect(() => {
    setSubHeaderData(props.subHeaderData);
  }, [props.subHeaderData]);

  // useEffect(() => {
  //   setData(props.sorted);
  // }, [props.sorted]);

  const handleCheckboxChange = (e, id, column) => {
    setData((prevData) => {
      return prevData.map((item, idx) => {
        if (idx === id) {
          // item.e.target.name = e.target.value;
          if (column.checkBoxOnChange) column.checkBoxOnChange(e, item);
          // column.checkBoxOnChange(e, {
          //   ...item,
          //   [e.target.name]: e.target.value,
          // });
          // return { ...item, [e.target.name]: !item.[e.target.name] };
        }
        return item;
      });
    });
  };

const getFileTypeIcon = (fileName) => {
  if (isEmptyString(fileName)) return null;
  const ext = fileName.split(".").pop().toLowerCase();
  switch (ext) {
    case "pdf":
      return <FaFilePdf className="file-icon file-icon-pdf" />;
    case "xls":
    case "xlsx":
      return <FaFileExcel className="file-icon file-icon-xlsx" />;
    case "doc":
    case "docx":
      return <FaFileWord className="file-icon file-icon-doc" />;
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
      return <FaFileImage className="file-icon file-icon-img" />;
    default:
      return <FaFile className="file-icon" />;
  }
};

  // const handleTextChange = (e, id, column) => {
  //   setData((prevData) => {
  //     return prevData.map((item, idx) => {
  //       if (idx === id) {
  //         if (column.inputOnChange) column.inputOnChange(e, item);
  //         // return { ...item, [e.target.name]: e.target.value };
  //       }
  //       return item;
  //     });
  //   });
  // };

  // const handleOnBlur = (e, id, column) => {
  //   setData((prevData) => {
  //     return prevData.map((item, idx) => {
  //       if (idx === id) {
  //         if (column.inputOnBlur) column.inputOnBlur(e, item);
  //         // return { ...item, [e.target.name]: e.target.value };
  //       }
  //       return item;
  //     });
  //   });
  // };
const handleTextChange = (e, id, column) => {
  const item = data[id];
  if (item && column.inputOnChange) column.inputOnChange(e, item);
};

const handleOnBlur = (e, id, column) => {
  const item = data[id];
  if (item && column.inputOnBlur) column.inputOnBlur(e, item);
};
  const requestSort = (key) => {
    let direction = "";
    sortConfig.key === key && sortConfig.direction === "asc"
      ? (direction = "desc")
      : (direction = "asc");
    handleSort(key, direction);
    setSortConfig({ key, direction });
  };

  /*
  const handleSort = (key, direction) => {
    if (key && !isEmptyArray(data)) {
      const sorted = [...data].sort((a, b) => {
        if (a[key] === null) return 1;
        if (b[key] === null) return -1;
        if (a[key] === null && b[key] === null) return 0;
        return (
          a[key].toString().localeCompare(b[key].toString(), "en", {
            numeric: true,
          }) * (direction === "asc" ? 1 : -1)
        );
      });
      setData(sorted);
    }
  };
  */
  const handleSort_Bkup = (key, direction) => {
    if (key && !isEmptyArray(data)) {
      const sorted = [...data].sort((a, b) => {
        if (a[key] === null) return 1;
        if (b[key] === null) return -1;
        if (a[key] === null && b[key] === null) return 0;
        return (
          a[key].toString().localeCompare(b[key].toString(), "en", {
            numeric: true,
          }) * (direction === "asc" ? 1 : -1)
        );
      });
      setData(sorted);
      if (typeof props.onSortComplete === "function") {
        props.onSortComplete(sorted, { key, direction });
      }
    }
  };

const handleSort = (key, direction) => {
  if (key && !isEmptyArray(data)) {
    const sorted = [...data].sort((a, b) => {
      if (a[key] === null) return 1;
      if (b[key] === null) return -1;
      if (a[key] === null && b[key] === null) return 0;

      const dateRegex = /^(\d{2})[/\-.](\d{2})[/\-.](\d{4})$/;
      const matchA = a[key].toString().match(dateRegex);
      const matchB = b[key].toString().match(dateRegex);

      if (matchA && matchB) {
        // MM-DD-YYYY (any separator: / - .) -> YYYYMMDD as a number
        const valueA = Number(matchA[3] + matchA[1] + matchA[2]);
        const valueB = Number(matchB[3] + matchB[1] + matchB[2]);
        return (valueA - valueB) * (direction === "asc" ? 1 : -1);
      }

      return (
        a[key].toString().localeCompare(b[key].toString(), "en", {
          numeric: true,
        }) * (direction === "asc" ? 1 : -1)
      );
    });
    setData(sorted);
    if (typeof props.onSortComplete === "function") {
      props.onSortComplete(sorted, { key, direction });
    }
  }
};

  const sortedData = () => {
    const sorted = setData(data);
  };

  const clickHandler = (e, column, row,rowIndex) => {
    if (column.clickHandler) {
      column.clickHandler(e, row[column.accessor], row,rowIndex);
    }
  };

  const headerClickHandler = (e, column) => {
    if (column.headerClickHandler) {
      column.headerClickHandler(e, column);
    }
  };

  const getClassName = (column) => {
    let className = "";
    /* check for allignmnet */
    if (column.alignment === "left") {
      className = "text-start";
    } else if (column.alignment === "right") {
      className = "text-end";
    } else if (column.alignment === "center") {
      className = "text-center";
    }
    /* check for width */
    /* min-width */
    if (column.mininWidth)
      className = className + " " + `min-wt-${column.mininWidth}`;
    // className.concat(" ", `min-wt-${column.mininWidth}`);
    /* max-width */
    if (column.maxWidth)
      className = className + " " + `max-wt-${column.maxWidth}`;
    // className.concat(" ", `max-wt-${column.maxWidth}`);
    /* check for customStyle */
    if (column.customStyle)
      className = className + " " + `${column.customStyle}`;
    //  className.concat(" ", `${column.customStyle}`);
    return className;
  };

  const getHeaderClassName = (column) => {
    let className = "";
    /* check for allignmnet */
    if (column.alignment === "left") {
      className = "text-start";
    } else if (column.alignment === "right") {
      className = "text-end";
    } else if (column.alignment === "center") {
      className = "text-center";
    }
    /* check for width */
    /* min-width */
    if (column.mininWidth)
      className = className + " " + `min-wt-${column.mininWidth}`;
    // className.concat(" ", `min-wt-${column.mininWidth}`);
    /* max-width */
    if (column.maxWidth)
      className = className + " " + `max-wt-${column.maxWidth}`;
    // className.concat(" ", `max-wt-${column.maxWidth}`);
    /* check for HeaderStyle */
    if (column.headerStyle)
      className = className + " " + `${column.headerStyle}`;
    //  className.concat(" ", `${column.customStyle}`);
    return className;
  };

  const GraphProvider = (column, row, data) => {
    if (column.getGraph) {
      return column.getGraph(column, row, data);
    }
  };

  const statusProvider = (column, status) => {
    if (column.getStatusCaption) {
      const finalStatus = column.getStatusCaption(status);
      return finalStatus;
    }
  };

  const getDisabled = (column, row, rowIndex, val) => {
    if (typeof column.getDisabled === "function") {
      return column.getDisabled(column, row, rowIndex, val);
    }
  };

  const toggleFullscreen = () => {
    setFullscreen(!isFullscreen);
    /* If entering fullscreen, add an event listener to exit fullscreen on escape key press */
    if (!isFullscreen) {
      document.addEventListener("keydown", handleEscapeKey);
    } else {
      /* If exiting fullscreen, remove the event listener */
      document.removeEventListener("keydown", handleEscapeKey);
    }
  };

  const handleEscapeKey = (event) => {
    if (event.key === "Escape") {
      setFullscreen(false);
    }
  };

  const labelButtonClickHandler = (e) => {
    if (props.labelButtonClickHandler) {
      props.labelButtonClickHandler(e);
    }
  };

  const chartButtonClickHandler = (e) => {
    if (props.chartButtonClickHandler) {
      props.chartButtonClickHandler(e);
    }
  };

  const selectPtLines = (e) => {
    if (props.selectPtLines) {
      props.selectPtLines(e);
    }
  };

  const unselectPtLines = (e) => {
    if (props.unselectPtLines) {
      props.unselectPtLines(e);
    }
  };

  const loadFirst = (e) => {
    if (props.isShowPagination) {
      props.loadFirst(e);
    }
  };
  const loadPrevious = (e) => {
    if (props.isShowPagination) {
      props.loadPrevious(e);
    }
  };
  const loadNext = (e) => {
    if (props.isShowPagination) {
      props.loadNext(e);
    }
  };
  const loadLast = (e) => {
    if (props.isShowPagination) {
      props.loadLast(e);
    }
  };

  const handleOnchange = (e) => {
    if (props.isShowPagination) {
      props.handleOnchange(e);
    }
  };

  const handlePaginationOnBlur = (e) => {
    if (props.isShowPagination) {
      props.handlePaginationOnBlur(e);
    }
  };

  const onPageClick = (e) => {
    if (props.isShowPagination) {
      props.onPageClick(e);
    }
  };

  const labelPDFButtonClickHandler = (e) => {
    if (props.labelPDFButtonClickHandler) {
      props.labelPDFButtonClickHandler(e);
    }
  };

  const excelResetButtonClickHandler = (e) => {
    if (props.excelResetButtonClickHandler) {
      props.excelResetButtonClickHandler(e);
    }
  };

  const getRowClassName = (row, rowIndex) => {
    if (props.getRowClassName) {
      return props.getRowClassName(row, rowIndex) || "";
    }
    return "";
  };


  
  // Selection stats + filter tabs toolbar.
  // Rendered only when the parent passes selectionStats (opt-in, so tables
  // that don't need selection tracking are unaffected).
  const renderSelectionToolbar = () => {
    if (!props.selectionStats && !props.onFilterChange) return null;

    const stats = props.selectionStats || { total: 0, selected: 0 };
    const remaining = stats.total - stats.selected;

    return (
      <div className="roll-selection-toolbar">
        {/* {props.selectionStats && (
          <div className="roll-stats-row">
            <div className="roll-stat-card roll-stat-selected">
              <div className="roll-stat-label">Selected</div>
              <div className="roll-stat-value">{stats.selected}</div>
            </div>
            <div className="roll-stat-card">
              <div className="roll-stat-label">Remaining</div>
              <div className="roll-stat-value">{remaining}</div>
            </div>
            <div className="roll-stat-card">
              <div className="roll-stat-label">Total rolls</div>
              <div className="roll-stat-value">{stats.total}</div>
            </div>
          </div>
        )} */}

        {props.onFilterChange && (
          <div className="roll-filter-row">
            <span className="roll-filter-label">Show</span>
            <Button
              size="sm"
              className={`roll-filter-tab ${
                props.activeFilter === "all" ? "active" : ""
              }`}
              onClick={() => props.onFilterChange("all")}
            >
              All {props.selectionStats ? `(${stats.total})` : ""}
            </Button>
            <Button
              size="sm"
              className={`roll-filter-tab ${
                props.activeFilter === "selected" ? "active" : ""
              }`}
              onClick={() => props.onFilterChange("selected")}
            >
              Selected {props.selectionStats ? `(${stats.selected})` : ""}
            </Button>
            <Button
              size="sm"
              className={`roll-filter-tab ${
                props.activeFilter === "unselected" ? "active" : ""
              }`}
              onClick={() => props.onFilterChange("unselected")}
            >
              Unselected {props.selectionStats ? `(${remaining})` : ""}
            </Button>
          </div>
        )}
      </div>
    );
  };

  // Single source of truth for a cell's TEXT content: computed value,
  // status caption, date formatting, numeric formatting, or raw value â€”
  // with search highlighting applied once at the end.
  // This is the ONLY place that should format/highlight isCalculated,
  // isStatus, isDateFormate, isNumeric, or plain-text columns. Don't add
  // a second standalone {column.isNumeric ? ... : null} (etc.) block
  // elsewhere in the <td> â€” that causes the value to render twice, and
  // whichever block skips this function never gets highlighted.
  const renderCellContent = (column, row) => {
    let rawValue = row[column.accessor];

    if (column.isCalculated) {
      rawValue = column.getCalculatedValue(column, row);
    } else if (column.getStatusCaption) {
      rawValue = statusProvider(column, rawValue);
    } else if (column.isDateFormate && rawValue) {
      rawValue = dateFormate(rawValue);
    } else if (column.isNumeric && rawValue !== null && rawValue !== undefined) {
      rawValue = toCommaSeperatedAmount(rawValue);
    }

    if (
      props.enableHighlight &&
      props.searchText &&
      rawValue !== null &&
      rawValue !== undefined
    ) {
      const search = String(props.searchText);
      const escapedSearch = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const parts = String(rawValue).split(new RegExp(`(${escapedSearch})`, "gi"));

      return parts.map((part, index) =>
        part.toLowerCase() === search.toLowerCase() ? (
          <span key={index} style={{ backgroundColor: "yellow" }}>
            {part}
          </span>
        ) : (
          part
        )
      );
    }

    return rawValue;
  };

  // Shared class for the cell wrapper div rendered by renderCellContent.
  const getCellTextClassName = (column) =>
    column.isNumeric
      ? "isNumberic"
      : column.isDateFormate
      ? "isDateFormate"
      : column.isStatus
      ? "status"
      : "";

      const getVirtuosoHeight = () => {
  const rowHeightPx = 40;   // approx row height, adjust to match your CSS
  const headerHeightPx = 45; // approx header height
  const maxVh = isFullscreen ? 100 : 80;
  const maxPx = (window.innerHeight * maxVh) / 100;

  const contentPx = headerHeightPx + (data?.length || 0) * rowHeightPx;

  return `${Math.min(contentPx, maxPx)}px`;
};

  return (
    <>
      {props.enableVritualizer ? (
        <div
          className={`header_div table-wrap card ${
            isFullscreen ? " full-screen" : ""
          }`}
        >
          <div className="title-wrap">
            <div className="title">
              {/* {props.label && <FormLabel>{props.label}</FormLabel>} */}
              <Row>
                {props.label && (
                  <FormLabel className="table_title">{props.label}</FormLabel>
                )}

                {props.isShowLabelButton && (
                  <Button
                    id="fabric_Add_Button"
                    className="table-label-btn"
                    onClick={(e) => labelButtonClickHandler(e)}
                    disabled={props.isLabelButtonDisable}
                  >
                    Add
                  </Button>
                )}

                {props.isShowExcelResetButton && (
                  <Button
                    size="sm"
                    id="fabric_Add_Button"
                    // className="table-label-btn"
                    onClick={(e) => excelResetButtonClickHandler(e)}
                    disabled={props.isExcelResetButtonDisable}
                  >
                    {/* {props.labelButtonRender ? props.labelButtonRender : "add"} */}
                    {props.renderExcelResetButton}
                  </Button>
                )}
              </Row>
            </div>

              {/* ADD THIS — was missing in the virtualized branch */}
            <div className="new">
              {props.isShowSelectButton && (
                <div className="Select-bts">
                  <Button
                    className="table-label-btn_v1"
                    onClick={(e) => selectPtLines(e)}
                    disabled={props.isSelectCriteria}
                  >
                    Select
                  </Button>
                  <Button
                    className="table-label-btn_v1"
                    onClick={(e) => unselectPtLines(e)}
                    disabled={props.isUnSelectCriteria}
                  >
                    Un Select
                  </Button>
                </div>
              )}
            </div>

            <div className="">
              {props.isShowChartButton && (
                <Button
                  size="lg"
                  id="fabric_Add_Button"
                  onClick={(e) => chartButtonClickHandler(e)}
                  disabled={props.isLabelButtonDisable}
                >
                  {/* {props.labelButtonRender ? props.labelButtonRender : "add"} */}
                  {props.chartButtonRender}
                </Button>
              )}{" "}
              {isFullscreen ? (
                <MdFullscreenExit
                  onClick={toggleFullscreen}
                  className="full-screen-toggle"
                />
              ) : (
                <MdFullscreen
                  onClick={toggleFullscreen}
                  className="full-screen-toggle"
                />
              )}
            </div>
          </div>
          {renderSelectionToolbar()}
          <div>
            <TableVirtuoso
            //  style={{ height: `${isFullscreen ? "100vh " : "80vh"}` }}
            style={{ height: getVirtuosoHeight() }}
              data={data}
              // components={{
              //   Table: ({ style, ...props }) => (
              //     <table
              //       id="custom-table"
              //       className={`${props.isResizable ? "resizable" : ""}`}
              //       {...props}
              //       style={{ ...style }}
              //     />
              //   ),
              // }}
              // components={{
              //   Table: ({ style, ...tblProps }) => (
              //     <table
              //       id="custom-table"
              //       className={`${tblProps.isResizable ? "resizable" : ""}`}
              //       {...tblProps}
              //       style={{ ...style }}
              //     />
              //   ),
              //   TableRow: (rowProps) => {
              //     const row = data[rowProps["data-index"]];
              //     return (
              //       <tr
              //         {...rowProps}
              //         className={getRowClassName(row, rowProps["data-index"])}
              //       />
              //     );
              //   },
              // }}

              components={virtuosoComponents}
context={{ data, getRowClassName }}
              fixedHeaderContent={() => (
                <>
                  <tr>
                    {columns.map((column, columnIndex) =>
                      !column.isColSpan ? (
                        !column.isTopHeader ? (
                          <th
                            rowspan="2"
                            key={columnIndex}
                            className={
                              isEmptyString(column.headerStyle)
                                ? `${getHeaderClassName(column)}`
                                : `${getHeaderClassName(column)}  ${
                                    column.headerStyle
                                  }`
                            }
                          >
                            {column.isHeaderButton ? (
                              <div
                                className=""
                                n
                                onClick={() =>
                                  column.sortable &&
                                  requestSort(column.accessor)
                                }
                              >
                                <Button
                                  onClick={(e) => headerClickHandler(e, column)}
                                  disabled={column.headerDisable}
                                  size="sm"
                                  id="table-header-btn"
                                >
                                  {column.headerRender}
                                </Button>
                              </div>
                            ) : (
                              <div
                                className=""
                                onClick={() =>
                                  column.sortable &&
                                  requestSort(column.accessor)
                                }
                              >
                                {column.header}
                                {column.sortable && (
                                  <span className="short-toggle">
                                    {sortConfig.key === column.accessor &&
                                    sortConfig.direction === "asc" ? (
                                      <DropDwnDown />
                                    ) : (
                                      <DropDwnUp />
                                    )}
                                  </span>
                                )}
                              </div>
                            )}
                            {column.isSubHeader ? (
                              !isEmpty(subHeaderData) ? (
                                <div className="bg-white text-danger text-end">
                                  {toCommaSeperatedAmount(
                                    subHeaderData[column.subHeaderAccessor],
                                  )}
                                </div>
                              ) : null
                            ) : null}
                          </th>
                        ) : (
                          <th
                            colspan={column.colSpan}
                            key={columnIndex}
                            className={
                              isEmptyString(column.headerStyle)
                                ? `${getHeaderClassName(column)}`
                                : `${getHeaderClassName(column)}  ${
                                    column.headerStyle
                                  }`
                            }
                          >
                            <div className="">{column.header}</div>
                          </th>
                        )
                      ) : null,
                    )}
                  </tr>
                  {props.isEnableSpan ? (
                    <tr>
                      {columns.map((column, columnIndex) =>
                        column.isColSpan ? (
                          <th
                            key={columnIndex}
                            className={
                              isEmptyString(column.headerStyle)
                                ? `${getHeaderClassName(column)}`
                                : `${getHeaderClassName(column)}  ${
                                    column.headerStyle
                                  }`
                            }
                          >
                            <div
                              className=""
                              onClick={() =>
                                column.sortable && requestSort(column.accessor)
                              }
                            >
                              {column.header}
                              {column.sortable && (
                                <span className="short-toggle">
                                  {sortConfig.key === column.accessor &&
                                  sortConfig.direction === "asc" ? (
                                    <DropDwnDown />
                                  ) : (
                                    <DropDwnUp />
                                  )}
                                </span>
                              )}
                            </div>{" "}
                          </th>
                        ) : null,
                      )}
                    </tr>
                  ) : null}
                  {/* {columns.map((column, columnIndex) => (
                    <th
                      key={columnIndex}
                      className={
                        isEmptyString(column.headerStyle)
                          ? `${getHeaderClassName(column)}`
                          : `${getHeaderClassName(column)}  ${
                              column.headerStyle
                            }`
                      }
                    >
                      {column.isHeaderButton ? (
                        <div
                          className=""
                          onClick={() =>
                            column.sortable && requestSort(column.accessor)
                          }
                        >
                          <Button
                            onClick={(e) => headerClickHandler(e, column)}
                            disabled={column.headerDisable}
                            size="sm"
                            id="table-header-btn"
                          >
                            {column.headerRender}
                          </Button>
                        </div>
                      ) : (
                        <div
                          className=""
                          onClick={() =>
                            column.sortable && requestSort(column.accessor)
                          }
                        >
                          {column.header}
                          {column.sortable && (
                            <span className="short-toggle">
                              {sortConfig.key === column.accessor &&
                              sortConfig.direction === "asc" ? (
                                <DropDwnDown />
                              ) : (
                                <DropDwnUp />
                              )}
                            </span>
                          )}
                        </div>
                      )}
                      {column.isSubHeader ? (
                        !isEmpty(subHeaderData) ? (
                          <div className="bg-white text-danger text-right">
                            {toCommaSeperatedAmount(
                              subHeaderData[column.subHeaderAccessor]
                            )}
                          </div>
                        ) : null
                      ) : null}
                    </th>
                  ))} */}
                </>
              )}
              itemContent={(rowIndex, row) => row.isDeleted !== true ?  (
                <>
                  {data != null
                    ? columns.map((column, columnIndex) =>
                        !column.isTopHeader ? (
                          <td
                            key={columnIndex}
                            className={getClassName(column)}
                           
                          >
                            {column.isButton ? (
                              <div className="table-flex">
                                <Button
                                  className="table-btn"
                                  onClick={(e) => clickHandler(e, column, row)}
                                  disabled={column.disable}
                                  size="sm"
                                >
                                  {column.buttonRender}
                                </Button>
                              </div>
                            ) : null}
                            {column.isNumberFormat ? (
                              <NumberFormatInputbox
                                name={column.accessor}
                                onChange={(e) =>
                                  handleTextChange(e, rowIndex, column)
                                }
                                onBlur={(e) =>
                                  handleOnBlur(e, rowIndex, column)
                                }
                                className="text-end col-sm-12 p-0 pr-1"
                                value={row[column.accessor]}
                                // decimalScale={2}
                                decimalScale={
                                  column.decimalScale != null &&
                                  column.decimalScale != undefined &&
                                  column.decimalScale >= 0
                                    ? column.decimalScale
                                    : 2
                                }
                              disabled={column.disable}
                            //       disabled={
                            // column.isSpecialDisabled
                            //     ? getDisabled(row, rowIndex, column)
                            //        : column.disable
                            //             }
                              />
                            ) : null}
                            {column.isImage ? (
                              <div className="table-flex">
                                <img
                                  src={row[column.accessor]}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src = noImage;
                                  }}
                                  alt={column.accessor}
                                  width={40}
                                  height={40}
                                  mode="fit"
                                />
                              </div>
                            ) : null}

                            {column.isGraph ? (
                              <div className="grap-wrap">
                                <div
                                  className={GraphProvider(
                                    column,
                                    row,
                                    row[column.accessor],
                                  )}
                                ></div>
                              </div>
                            ) : null}

                            {column.isCheckBox ? (
                              <div className="table-flex">
                                <InputCheckbox
                                  name={column.accessor}
                                  data-tag="allowRowEvents"
                                  onChange={(e) =>
                                    handleCheckboxChange(e, rowIndex, column)
                                  }
                                  checked={row[column.accessor]}
                                  disabled={column.disable}
                                  disableLabel={true}
                                ></InputCheckbox>
                              </div>
                            ) : null}

                            {column.isHyperLink && column.isNumeric ? (
                              <div
                                className="hyperLink"
                                onClick={(e) => clickHandler(e, column, row,rowIndex)}
                              >
                                {column.isNumeric
                                  ? toCommaSeperatedAmount(row[column.accessor])
                                  : row[column.accessor]}
                              </div>
                            ) : null}

                            {column.isHyperLink && !column.isNumeric ? (
                              <div
                                className="hyperLink"
                                onClick={(e) => clickHandler(e, column, row,rowIndex)}
                              >
                                  {/* {column.isDocument ? getFileTypeIcon(row[column.accessor]) : null} */}
                                   {row[column.accessor]}
                                {/* {row[column.accessor]} */}
                              </div>
                            ) : null}

                            
                           {column.isDocument ? (
  <div>
    {getFileTypeIcon(row[column.accessor])}
  </div>
) : null}
                            {column.isSpecial ? (
                              <div
                                className="hyperLink"
                                onClick={(e) => clickHandler(e, column, row)}
                              >
                                {row[column.accessor]} -{" "}
                                {row[column.specialAccessor]}
                              </div>
                            ) : null}

                            {!column.isHyperLink &&
                            !column.isInputTexBox &&
                            !column.isCheckBox &&
                            !column.isButton &&
                            !column.isNumberFormat &&
                            !column.isImage &&
                            !column.isGraph &&
                            !column.isSpecial ? (
                              <div className={getCellTextClassName(column)}>
                                {renderCellContent(column, row)}
                              </div>
                            ) : null}
                          </td>
                        ) : null,
                      )
                    : null}
                  {data.length != 0 ? null : (
                    <div className="no_Data_small">{"NO DATA"}</div>
                  )}
                </>
                ) : null
              }
            />
          </div>
        </div>
      ) : (
        <div
          className={`header_div table-wrap card ${
            isFullscreen ? " full-screen" : ""
          } ${props.cstmStyle}`}
        >
          <div className="title-wrap">
            <div className="title">
              {/* {props.label && <FormLabel>{props.label}</FormLabel>} */}
              <Row>
                {props.label && (
                  <FormLabel className="table_title">{props.label}</FormLabel>
                )}
              </Row>
            </div>
            <div className="new">
              {props.isShowSelectButton && (
                <div className="Select-bts">
                  <Button
                    className="table-label-btn_v1"
                    onClick={(e) => selectPtLines(e)}
                    disabled={props.isSelectCriteria}
                  >
                    Select
                  </Button>
                  <Button
                    className="table-label-btn_v1"
                    onClick={(e) => unselectPtLines(e)}
                    disabled={props.isUnSelectCriteria}
                  >
                    Un Select
                  </Button>
                </div>
              )}
            </div>
            <div className="">
              {" "}
              {props.isShowChartButton && (
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  onClick={(e) => chartButtonClickHandler(e)}
                  disabled={props.isLabelButtonDisable}
                >
                  {/* {props.labelButtonRender ? props.labelButtonRender : "add"} */}
                  {props.chartButtonRender}
                </Button>
              )}
              {props.isShowLabelButton && (
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  // className="table-label-btn"
                  onClick={(e) => labelButtonClickHandler(e)}
                  disabled={props.isLabelButtonDisable}
                >
                  {/* {props.labelButtonRender ? props.labelButtonRender : "add"} */}
                  {props.labelButtonRender}
                </Button>
              )}
              {props.isShowLabelButton && (
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  // className="table-label-btn"
                  onClick={(e) => labelPDFButtonClickHandler(e)}
                  disabled={props.isLabelButtonDisable}
                >
                  {/* {props.labelButtonRender ? props.labelButtonRender : "add"} */}
                  {props.labelButtonRenderPDF}
                </Button>
              )}
              {isFullscreen ? (
                <MdFullscreenExit
                  onClick={toggleFullscreen}
                  className="full-screen-toggle"
                />
              ) : (
                <MdFullscreen
                  onClick={toggleFullscreen}
                  className="full-screen-toggle"
                />
              )}
            </div>
            {/* <div class="secondary_module_header"> */}
          </div>
          {/* {props.isShowPagination && (
            <div className="custom_Pagination">
          
          <PaginationDashboard
            loadFirst={(e) => loadFirst(e)}
            loadPrevious={(e) => loadPrevious(e)}
            loadNext={(e) => loadNext(e)}
            loadLast={(e) => loadLast(e)}
            currentPage={props.currentPage}
            totalPages={props.totalPages}
            handleOnchange={(e) => handleOnchange(e)}
            handlePaginationOnBlur={(e) => handlePaginationOnBlur(e)}
          />
        </div>
      )}  */}
  {renderSelectionToolbar()}
          <Row>
            <div>
              {props.isShowInputTextbox && (
                <div>
                  <Row>
                    <Col sm="1">
                      <FormLabel>{props.subHeaderData.lab_1}</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="value_1"
                        type="text"
                        value={props.subHeaderData.value_1}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>{props.subHeaderData.lab_2}</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="value_2"
                        type="text"
                        value={props.subHeaderData.value_2}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>{props.subHeaderData.lab_3}</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="value_3"
                        type="text"
                        value={props.subHeaderData.value_3}
                        disabled={true}
                      />
                    </Col>

                    <Col sm="1">
                      <FormLabel>{props.subHeaderData.lab_4}</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="value_4"
                        type="text"
                        value={props.subHeaderData.value_4}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="2">
                      <FormLabel>{props.subHeaderData.lab_5}</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="value_5"
                        type="text"
                        value={props.subHeaderData.value_5}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </Row>

          {props.isShowPagination && (
            <div className="custom_Pagination">
              {/* TESTING THE PAGINATION */}
              <PaginationComponent
                loadPrevious={(e) => loadPrevious(e)}
                loadNext={(e) => loadNext(e)}
                currentPage={props.currentPage}
                totalPages={props.totalPages}
                handleOnchange={(e) => handleOnchange(e)}
                handlePaginationOnBlur={(e) => handlePaginationOnBlur(e)}
                onPageClick={(e) => onPageClick(e)}
                isShowRowPerPage={props.isShowRowPerPage}
              />
            </div>
          )}

          {/* </div> */}
          <table
            id="custom-table"
            className={`${props.isResizable ? "resizable" : ""}`}
          >
            <thead>
              <tr>
                {columns.map((column, columnIndex) =>
                  !column.isColSpan ? (
                    !column.isTopHeader ? (
                      <th
                        rowspan="2"
                        key={columnIndex}
                        className={
                          isEmptyString(column.headerStyle)
                            ? `${getHeaderClassName(column)}`
                            : `${getHeaderClassName(column)}  ${
                                column.headerStyle
                              }`
                        }
                      >
                        {column.isHeaderButton ? (
                          <div
                            className=""
                            n
                            onClick={() =>
                              column.sortable && requestSort(column.accessor)
                            }
                          >
                            <Button
                              onClick={(e) => headerClickHandler(e, column)}
                              disabled={column.headerDisable}
                              size="sm"
                              id="table-header-btn"
                            >
                              {column.headerRender}
                            </Button>
                          </div>
                        ) : (
                          <div
                            className=""
                            onClick={() =>
                              column.sortable && requestSort(column.accessor)
                            }
                          >
                            {column.header}
                            {column.sortable && (
                              <span className="short-toggle">
                                {sortConfig.key === column.accessor &&
                                sortConfig.direction === "asc" ? (
                                  <DropDwnDown />
                                ) : (
                                  <DropDwnUp />
                                )}
                              </span>
                            )}
                          </div>
                        )}
                        {column.isSubHeader ? (
                          !isEmpty(subHeaderData) ? (
                            <div className="bg-white text-danger text-end">
                              {toCommaSeperatedAmount(
                                subHeaderData[column.subHeaderAccessor],
                              )}
                            </div>
                          ) : null
                        ) : null}
                      </th>
                    ) : (
                      <th
                        colspan={column.colSpan}
                        key={columnIndex}
                        className={
                          isEmptyString(column.headerStyle)
                            ? `${getHeaderClassName(column)}`
                            : `${getHeaderClassName(column)}  ${
                                column.headerStyle
                              }`
                        }
                      >
                        <div className="">{column.header}</div>
                      </th>
                    )
                  ) : null,
                )}
              </tr>
              {props.isEnableSpan ? (
                <tr>
                  {columns.map((column, columnIndex) =>
                    column.isColSpan ? (
                      <th
                        key={columnIndex}
                        className={
                          isEmptyString(column.headerStyle)
                            ? `${getHeaderClassName(column)}`
                            : `${getHeaderClassName(column)}  ${
                                column.headerStyle
                              }`
                        }
                      >
                        <div
                          className=""
                          onClick={() =>
                            column.sortable && requestSort(column.accessor)
                          }
                        >
                          {column.header}
                          {column.sortable && (
                            <span className="short-toggle">
                              {sortConfig.key === column.accessor &&
                              sortConfig.direction === "asc" ? (
                                <DropDwnDown />
                              ) : (
                                <DropDwnUp />
                              )}
                            </span>
                          )}
                        </div>{" "}
                      </th>
                    ) : null,
                  )}
                </tr>
              ) : null}
            </thead>
            {data != null ? (
              <tbody>
                {data.map((row, rowIndex) =>  row.isDeleted !== true ? (
                  // <tr key={rowIndex} className=""> //Bkup For Highligthing The Row
                  <tr key={rowIndex} className={getRowClassName(row, rowIndex)}>
                    {columns.map((column, columnIndex) =>
                      !column.isTopHeader ? (
                        <td key={columnIndex} className={getClassName(column)}>
                          {column.isInputTexBox ? (
                            <input
                              type="text"
                              value={row[column.accessor]}
                              name={column.accessor}
                              className="text-end col-sm-12 p-0 pr-1"
                              onChange={(e) =>
                                handleTextChange(e, rowIndex, column)
                              }
                              disabled={column.disable}
                            />
                          ) : null}

                          {column.isNumberFormat ? (
                            <NumberFormatInputbox
                              name={column.accessor}
                              onChange={(e) =>
                                handleTextChange(e, rowIndex, column)
                              }
                              onBlur={(e) => handleOnBlur(e, rowIndex, column)}
                              className="text-end col-sm-12 p-0 pr-1"
                              value={row[column.accessor]}
                              // decimalScale={2}
                              decimalScale={
                                column.decimalScale != null &&
                                column.decimalScale != undefined &&
                                column.decimalScale >= 0
                                  ? column.decimalScale
                                  : 2
                              }
                              disabled={
                                column.isSpecialDisabled
                                  ? getDisabled(
                                      column,
                                      row,
                                      rowIndex,
                                      row[column.accessor],
                                    )
                                  : column.disable
                              }
                            />
                          ) : null}

                          {column.isCheckBox ? (
                            <div className="table-flex">
                              <InputCheckbox
                                name={column.accessor}
                                data-tag="allowRowEvents"
                                onChange={(e) =>
                                  handleCheckboxChange(e, rowIndex, column)
                                }
                                checked={row[column.accessor]}
                                disabled={column.disable}
                                disableLabel={true}
                              ></InputCheckbox>
                            </div>
                          ) : null}

                          {column.isButton ? (
                            <div className="table-flex">
                              <Button
                                className="table-btn"
                                onClick={(e) => clickHandler(e, column, row)}
                                disabled={column.disable}
                                size="sm"
                              >
                                {column.buttonRender}
                              </Button>
                            </div>
                          ) : null}

                          {column.shortCutPopUpMenu ? (
                            <div className="table-flex">
                              {column.buttonRender(row)}
                            </div>
                          ) : null}

                          {column.isImage ? (
                            <div className="table-flex">
                              <img
                                src={row[column.accessor]}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = noImage;
                                }}
                                alt={column.accessor}
                                width={40}
                                height={40}
                                mode="fit"
                              />
                            </div>
                          ) : null}

                          {column.isGraph ? (
                            <div className="grap-wrap">
                              <div
                                className={GraphProvider(
                                  column,
                                  row,
                                  row[column.accessor],
                                )}
                              ></div>
                            </div>
                          ) : null}

                          {column.isHyperLink && column.isNumeric ? (
                            <div
                              className="hyperLink"
                              onClick={(e) => clickHandler(e, column, row,rowIndex)}
                            >
                              {column.isNumeric
                                ? toCommaSeperatedAmount(row[column.accessor])
                                : row[column.accessor]}
                            </div>
                          ) : null}

                          {column.isHyperLink && !column.isNumeric ? (
                            <div
                              className="hyperLink"
                              onClick={(e) => clickHandler(e, column, row,rowIndex)}
                            >
                              {row[column.accessor]}
                            </div>
                          ) : null}
                                                      
                           {column.isDocument ? (
  <div>
    {getFileTypeIcon(row[column.accessor])}
  </div>
) : null}

                          {column.isSpecial ? (
                            <div
                              className="hyperLink"
                              onClick={(e) => clickHandler(e, column, row)}
                            >
                              {row[column.accessor]} -{" "}
                              {row[column.specialAccessor]}
                            </div>
                          ) : null}

                          {!column.isHyperLink &&
                          !column.isInputTexBox &&
                          !column.isCheckBox &&
                          !column.isButton &&
                          !column.isNumberFormat &&
                          !column.isImage &&
                          !column.isGraph &&
                          !column.shortCutPopUpMenu &&
                          !column.isSpecial ? (
                            <div className={getCellTextClassName(column)}>
                              {renderCellContent(column, row)}
                            </div>
                          ) : null}
                        </td>
                      ) : null,
                    )}
                  </tr>
                  ) : null
                )}
              </tbody>
            ) : null}
          </table>
          {data.length != 0 ? null : (
            <div className="no_Data_small">{"NO DATA"}</div>
          )}
        </div>
      )}
    </>
  );
}
